import { getLocalString } from 'pf-core/utilities';
import styles from '../styles.module.css';
import eyeIcon from './../../../assets/img/eye-icon.svg';
import { ErrorBox } from './ErrorBox';
import PropTypes from 'prop-types';

export const Form = ({
  handleChange,
  isValid,
  handleSubmit,
  isLoading,
  passcode,
  error,
  isPasswordVisible,
  handleTogglePasswordVisibility
}) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      {error && <ErrorBox />}
      <div className={styles.passwordWrapper}>
        <input
          type={isPasswordVisible ? 'text' : 'password'}
          value={passcode}
          style={{ borderColor: error ? 'var(--color-legacy-red-600)' : '' }}
          placeholder={getLocalString('Passcode', 'Passcode')}
          className={styles.passcodeInput}
          onChange={handleChange}
        />
        <button
          type="button"
          onClick={handleTogglePasswordVisibility}
          className={styles.eyeIcon}
          aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
        >
          <img src={eyeIcon} alt="Icon" width="17" height="17" />
        </button>
      </div>
      <button
        className={styles.button}
        disabled={!isValid || isLoading}
        type="submit"
      >
        {isLoading
          ? getLocalString('Submitting...', 'Submitting...')
          : getLocalString('Submit & Download', 'Submit & Download')}
      </button>
    </form>
  );
};

Form.propTypes = {
  handleChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  passcode: PropTypes.string,
  error: PropTypes.string.isRequired,
  isPasswordVisible: PropTypes.bool.isRequired,
  handleTogglePasswordVisibility: PropTypes.func.isRequired
};
